import esLocale from "element-ui/lib/locale/lang/es";
const es = {
  //西班牙语 Spanish
  login: {
    buttoo: {
      add: "新增",
    },
  },
  dialog: {
    buttton: {
      close: "关闭",
    },
    ReportError: {
      //未对应
      next: "Next",
      h1: "Report Errors allows users to communicate with us to solve any data issues and improve data quality.",
      li1: "If you find any data problems or have a question about this data",
      li2: "If you want to contribute company information to improve this data",
      li3: "If you choose not to disclose your own company information that you might consider private",
      li4: "If you have any constructive suggestions for us to improve services",
      h2: "All comments submitted are subject to data verification. Users must complete your own user profile as our representative may contact you for authentication and verification of your company any rights to represent your company.",
      //未对应
    },
  },
  Home: {
    //未对应
    Applications: "Applications",
    SearchCompanies: "Search Companies",
    SearchTrade: "Search Trade",
    SearchRisks: "Search Risks",
    SearchCountries: "Search Countries",
    SearchNews: "Search News",
    SearchLeads: "Search Leads",
    SearchSanctions: "Search Sanctions ",
    RiskScan: "Risk Scan",
    SearchRelationship: "Search Relationship",
    DataServices: "Data Services",
    //未对应

    selectCountry: "Seleccionar país",
    keWord: "Palabra clave",
    firstWord: "Texto (palabras de la izquierda)",
    search: "Buscar",
    homeSeachTitle: "Enfoque en los negocios globales",
    homeTitleDetail:
      "CSI, una firma de investigación y TI basada en datos, se especializa en crédito, riesgo y big data. Ofrece herramientas digitales a inversores y profesionales de negocios globales, aprovechando análisis y algoritmos avanzados para brindar información visual y rápida que facilita una toma de decisiones más inteligente.",
    phoneTitleDetail:
      "Para buscar, ver y obtener información de la empresa rápidamente, también puede usar la aplicación de CSI en su teléfono.",

    //未对应
    searchCompanyNum:
      "Search 500+ million companies in 200+ countries and territories",
    IndustryAnalysis: "Industry Analysis",
    BusinessAnalytics: "Business Analytics",
    ImportExportData: "Import-Export Data",
    CompanyNews: "Company News",
    Sanctions: "Sanctions",
    BusinessIntelligence: "Business Intelligence",
    CompanyIdentityVerification: "Company Identity Verification",
    KYCSolutions: "KYC Solutions",
    OwnershipPenetration: "Ownership Penetration",
    CompanyFinancialAnalysis: "Company Financial Analysis",
    CreditRatings: "Credit Ratings",
    CreditReports: "Credit Reports",
    ESGRatings: "ESG Ratings",
    VendorScreening: "Vendor Screening ",
    MarketResearch: "Market Research ",
    EnterKeyword: "Enter Keyword",
    Country: "Country",
    Company: "Company",
    Person: "Person",
    Product: "Product",
    EnterPersonName: "Enter Person Name",
    EnterCountryName: "Enter Country Name",
    Entercompanyname: "Ingresar nombre de la empresa",
    EnterproductName: "Enter product keywords",
    newsHeadTitle:"Uncover the strategic insights behind every company headline",
    sanctionHeadTitle:"Navigate international trade with confidence by screening companies and products against global sanctions",
    //未对应
  },
  Toolbar: {
    Filter: "Filtrar",
    Select: "Seleccionar",
    Edit: "Editar",
    Sortby: "Ordenar por",
    Collect: "Recopilar",
    Saved: "Guardados",
    Compare: "Comparar",
    Export: "Exportar",
    Download: "Descargar",
    Update: "Actualizar",
    Reporterror: "Informar de un error",
    Share: "Compartir",
    //未对应
    ascending: "Ascendente",
    descending: "Descendente",
    Yourfolder: "Carpeta personalizada",
    RiskScanning: "Risk Scanning",
    CreditAssessment: "Credit Assessment",
    DataAnalysis: "Data Analysis",
    NewPortfolio: "New Portfolio",
    Print: "Print",
    Optimize:"Optimize",
  },
  AiZaba: {
    //未对应
    whatareyousearchingfor: "What are you searching for?",
    CreditAnalyst: "Credit Analyst",
    Assesses:
      "Assesses a company'screditworthiness,identifiesfinancial risks,ensuring secure transactionsthrough data analysis andcredit ratings.",
    LegalAdvisor: "Legal Advisor",
    Provides:
      "Provides compliance guidance,reviews contracts,andassesseslegarisks to ensure businessoperations align with lawsand avoid disputes.",
    BizConsultant: "Biz Consultant",
    Optimizes:
      "Optimizes supply chains,identifiesbuyers, andboosts sales by analyzingmarket trends and offeringtailored strategies to improve efficiency",
    EconomicAnalyst: "Economic Analyst",
    Analyzes:
      "Analyzes industry and regional economic trendshelping businesses makeinformed decisions, and staycompetitive.",
  },
  navigationBar: {
    Notifications: "Notificaciones", //通知
    MarkasRead: "Marcar como leído", //标记已读
    Viewall: "Ver todo", //查看全部
    SilverSubscriber: "Suscriptor Plata", //银级用户
    GoldSubscriber: "Suscriptor Oro", //金级用户
    SubscriptionExpires: "Fecha de vencimiento de la suscripción Oro", //未对应
    AvailableCredits: "Créditos disponibles", //可用积分
    AddCredits: "Añadir créditos", //购买积分
    IndivdualAccount: "Cuenta individual", //个人账号
    GroupAccount: "Cuenta de grupo", //集团账号
    //未对应
    OrdinaryUsers: "Ordinary users",
    UserAccount: "User Account",
    Roles: "Roles", //角色
  },
  ListofResults: {
    Country: "País",
    Industry: "Sector",
    CompanyType: "Tipo de empresa",
    CompanySize: "Tamaño de la empresa",
    CompanyStatus: "Estado de la empresa",
    CompanyName: "Nombre de la empresa",
    CoType: "Tipo de empresa",
    RegStatus: "Estado de registro",
    StateProvince: "Estado/Provincia",
    CityCounty: "Ciudad/Condado",
    DistrictCity: "Distrito/Ciudad",
    IncDate: "Fecha de constitución",
    LegalForm: "Forma jurídica",
    CoID: "ID de la empresa",
    TaxNo: "N.º de identificación fiscal",
    ListingInfo: "Información del listado",
    Phone: "Teléfono",
    Website: "Sitio web",
    Email: "Correo electrónico",
    LegalPerson: "Persona jurídica",
    PostCode: "Código postal",
    ISIC: "ISIC",
    IndustryDescription: "IDescripción del sector",
    NACE: "NACE",
    NAICS: "NAICS",
    CreditRating: "Calificación crediticia",
    SolvencyIndex: "Índice de solvencia",
    ProbabilityofDefault: "Probabilidad de impago",
    NoofEmployees: "N.º de empleados",
    Revenue: "Ingresos",
    TotalAsset: "Activo total",
    NetProfit: "Beneficio neto",
    ROA: "ROA",
    ROE: "ROE",
    ShowMore: "Mostrar más",

    //未对应
    SelectCountry: "Select Country",
    ClearAll: "Clear All",
    SelectIndustry: "Select Industry",
    ListedCompany: "Listed Company",
    YearsinBusiness: "Years in Business",
    Sharethisinformation: "Share this information",
    Pleaseaddress: "Please enter one or more email address",
    Example: "Example",
    message: "message",
    pleaseleaveamessage: "please leave a message",
    Include: "",
    thisaddress: "this company name,ID,address",
    CSIwebsite: "CSI website",
    Update: "Update",
    Iftheavailable:
      "If the available online data is insufficient or outdated, you can click the “Update” button to request an instant update for a fresh investigated business credit report from our local networking investigators or credit reporting agencies. The cost for this update is 1 credit per company. The update report typically takes between 24 and 72 hours to be delivered.",
    Abusinesscredit:
      "A business credit report provides detailed information about the subject company’s identification data, registry records, shareholding structure, company history, management description, related companies, actual operations, trade references, financial data and analysis, official public information such as litigation records and sanctions, and credit analysis and assessment.",
    Searchcompanies: "Search more emails on other companies",
    Rowsperpage: "Rows per page",
    Foundover: "Found over",
    results: "results",
    Remove: "Remove",
    Confirm: "Confirmar",
  },
  ContentTabs: {
    Background: "Antecedentes",
    BusinessActivities: "Actividades comerciales",
    Performance: "Rendimiento",
    Publications: "Publicaciones",
    CreditOpinion: "Opinión crediticia",
    MarketAnalysis: "Análisis de mercado",
    Snapshot: "Panorama general",
    Profile: "Perfil",
    Ownership: "Propiedad",
    RelatedCompanies: "Empresas relacionadas",
    Management: "Administración",
    Operations: "Operaciones",
    Locations: "Ubicaciones",
    Industry: "Sector",
    ImportExport: "Importación y exportación",
    SupplyChain: "Cadena de suministro",
    FinancialHighlights: "Información financiera destacada",
    RatioAnalysis: "Análisis de ratios",
    IndustryNorm: "Norma del sector",
    News: "Noticias",
    Sanctions: "Sanciones",
    IndustryStatistics: "Estadísticas del sector",
    RatingAnalysis: "Análisis de calificación",
    CompetitiveAnalysis: "Análisis competitivo",
  },
  Snapshot: {
    CompanyDQIdesc1:
      "The Data Quality Index (DQI) employs algorithms to assess different aspects of data, including completeness, validity, reliability of sources, consistency, timeliness, and bilingual support.",
    CompanyDQIdesc2:
      "The index is designed to assess the quality of data on a scale of 1 to 100, with higher scores indicating superior data quality. Algorithms can analyze data based on predefined rules or criteria, enabling objective and standardized measurements.",
    CompanyDQIdesc3:
      "Our Data Quality Index (DQI) serves as a reliable indicator, allowing users to quantitatively assess data quality. This enables data-driven decision-making and enhances the overall value and utility of the data.",
    CountryDQIdesc1:
      "The Data Quality Index (DQI) assesses the reliability, accuracy, and accessibility of data across countries, reflecting differences in digital infrastructure, governance, and transparency. Developed nations typically rank higher due to strong data systems, open policies, and advanced technology, while developing economies often struggle with gaps in infrastructure, regulation, or data-sharing practices.",
    CountryDQIdesc2:
      "Key factors include government transparency, data protection laws, and technological adoption. A high DQI enables better policymaking and business decisions, while a low score highlights areas needing investment.",
    CompanyDQI: "Índice de Calidad de la Empresa", //公司数据质量指数 DQI
    CountryDQI: "IQD del País", //国家数据质量指数 DQI
    CompanyTitle: "Data Quality Index (DQI) by Company",
    CountryTitle: "Data Quality Index (DQI) by Country",
    //未对应以上

    Address: "Dirección", //地址
    CountyCity: "Condado/Ciudad", //县/市
    ProvinceState: "Provincia/Estado", //省/州
    CountryRegion: "País/Región", //国家/地区
    ZipCode: "Código Postal", //邮政编码
    Website: "Sitio Web", //网站
    Email: "Correo Electrónico", //电邮
    Tel: "Teléfono", //电话
    LastUpdate: "Última Actualización", //最近更新
    DataSource: "Fuente de Datos", //数据来源
    LegalStatus: "Estatus Legal", //法定状况
    CoID: "ID de la Empresa", //公司ID
    CompanyType: "Tipo de Empresa", //公司类型
    RegistrationDate: "Fecha de Registro", //注册日期
    RegistrationStatus: "Estado de Registro", //注册状态
    Listed: "Cotizada", //上市信息
    CurrentOpperations: "Operaciones Actuales", //经营状况
    IndustryCode: "Código de Sector", //行业代码
    BusinessActivities: "Actividades Comerciales", //主营业务
    NoofEmployees: "N.° de Empleados", //员工数量
    NoofShareholders: "N.° de Accionistas", //股东数量
    Management: "Administración", //管理状况
    Performance: "Rendimiento", //业绩表现
    Revenue: "Ingresos", //收入
    Assets: "Activos", //资产
    ProfitLoss: "Ganancias/Pérdidas", //利润
    Growth: "Crecimiento", //公司增长
    Competitiveness: "Competitividad", //竞争力
    CreditOpinion: "Opinión Crediticia", //信用状况
    CreditRating: "Calificación Crediticia", //信用评级
    CreditScore: "Puntuación Crediticia", //信用评分
    ESGRating: "Calificación ESG", //ESG 评级
    Solvency: "Solvencia", //偿还能力
    Sanctions: "Sanciones", //全球制裁
    CoName: "Nombre de la empresa",
    //未对应
    RegName: "Reg. Name",
  },
  Profile: {
    CompareCompanies: "Compare Companies", //未对应
    AddaCompany: "Add a Company", //未对应
    CompanyProfile: "Perfil de la empresa", //基本资料
    CompanyName: "Nombre de la empresa", //公司名称
    NativeName: "Nombre de la empresa", //当地名称
    CompanyID: "ID de la empresa", //公司 ID
    VATNumber: "Número de IVA", //VAT号
    StockCode: "Código bursátil", //股票代码
    Listed: "Cotización", //上市日期
    RegistrationDate: "Fecha de registro", //注册日期
    LegalForm: "Forma jurídica", //公司性质
    CompanyType: "Tipo de empresa", //公司类型
    LegalStatus: "Estatuto jurídico", //注册状态
    Jurisdiction: "Jurisdicción", //司法管辖区
    RegisteredAddress: "Domicilio social", //注册地址
    ProvinceState: "Provincia/Estado", //省/州
    CountryRegion: "País/Región", //国家/地区
    ZipCode: "Código postal", //邮政编码
    OperatingAddress: "Dirección operativa", //经营地址
    LastUpdate: "Última actualización", //最近更新
    DataSource: "Fuente de datos", //数据来源
    History: "Historial", //历史记录
    //未对应
    RegisteredCapital: "Registered Capital",
    PaidinCapital: "Paid-in Capital",
    CountyCity: "Condado/Ciudad",
  },
  Ownership: {
    UltimateBeneficiary: "Beneficiario final", //最终受益人
    InvolvingIndividuals: "Involucrando a personas físicas", //涉及自然人股东
    InvolvingEnterprises: "Involucrando a empresas", //涉及法人股东
    ShareholderLevel: "Nivel de accionista", //股东层级x
    Name: "Nombre", //名称
    Country: "País", //国家/地区
    Location: "Ubicación", //地点
    Type: "Tipo", //类型
    Shares: "Acciones", //股份
    Relation: "Relación", //关系
    //未对应
    Individuals: "Individuals", //关系
    PartiesInvolved: "Parties Involved",
    RelatedCompany: "Related Company",
    CompanyShareholders: "Company Shareholders",
    NGOShareholders: "NGO Shareholders",
    NaturalPersonShareholder: "Natural Person Shareholder",
    SubjectInvestments: "Subject's Investments",
  },
  RelatedCompanies: {
    Total: "Total", //相关公司总计
    Entities: "Entidades", //法人实体
    Countries: "Países", //国家/地区
    Branches: "Sucursales", //分支机构
    RelatedComp: "Empresas relacionadas", //关联公司
    Name: "Nombre", //名称
    Country: "País", //国家/地区
    Location: "Ubicación", //地点
    Type: "Tipo", //类型
    Relation: "Relación", //关系
    //未对应
    BranchOffices: "Branch Offices",
    Individuals: "Individuals",
  },
  Management: {
    Management: "Direccion", //管理层
    ContactInfo: "Información de contacto", //联系人信息
    Countries: "Países", //国家/地区
    Name: "Nombre", //名称
    Position: "Puesto", //职位
    Department: "Departamento", //部门
    Country: "País", //国家/地区
    ShareholderNot: "Accionista o no", //是否股东
    Relation: "Relaciones", //关系
    Verification: "Verificación", //已验证
    Searchmoreemails: "Buscar más correos electrónicos", //搜索更多电邮
    Roles: "Roles", //角色
    EducationLevel: "Nivel educativo", //教育程度
    Phone: "Teléfono", //电话
    Email: "Correo electrónico", //电邮
    Verified: "Verificado", //已验证
    Searchmore: "Buscar más correos electrónicos de otras empresas", //搜索更多其他公司的电邮

    //未对应
    Pleaseentername: "Please enter name",
    PleaseenterWebsite: "Please enter Website",
    UserSelfVerification: "User Self Verification",
    Userverified: "User verified",
    Source: "Origen",
  },
  Operations: {
    Operations: "Operations",
    LineofBusiness: "Línea de negocio", //业务范围
    BusinessTerritories: "Territorios comerciales", //业务区域
    ImportExport: "Importación y exportación", //进出口信息
    Viewtradeinfo: "Ver más información comercial", //查看更多贸易信息
    ProductsServices: "Productos/Servicios", //产品/服务
    Products: "Productos", //产品
    ProductImage: "Imagen del producto", //产品图片
    ProductName: "Nombre del producto", //产品名称
    ProductDescription: "Descripción del producto", //产品描述
    Details: "Detalles", //详情
    Addproductinformation: "Añadir información del producto", //添加产品信息
    //未对应
    Showcaseyourcompany:
      "If you’d like to showcase your company’s products or services to the public, you can add your product and service information here. This is a great way to promote your business. Once we’ve reviewed your submission, your data will be published.",
  },
  Locations: {
    Locations: "Locations",
    CoName: "Nombre de la empresa", //业务范围
    Relationship: "Relación", //关系
    Type: "Tipo", //类型
    Country: "País", //国家/地区
    Location: "Ubicación", //地点
    Address: "Dirección", //地址
    Edit: "Editar", //编辑
    CompanyLocatiionsMap: "Ubicaciones de la empresa en el mapa", //地图中的公司位置
    Selectaddresstype: "Seleccionar tipo de dirección", //选择地址类型
    Subjectcompany: "Empresa objeto", //目标公司
    Subsidiary: "Filial", //子公司
    RegisteredAddress: "Domicilio social", //注册地址
    OperationAddress: "Dirección operativa", //运营地址
    All: "Todos", //全部
    //未对应
    Showlocation: "Show location ",
  },
  Industry: {
    IndustryTitle: "Título de la industria", //IndustryTitle
    IndustryDescription: "Descripción de la industria", //IndustryDescription
    ISIC: "CIIU", //ISIC
    ISICDescription: "Descripción CIIU", //ISICDescription
    NACE: "NACE", //NACEDescription
    NACEDescription: "Descripción NACE", //NACEDescription
    NAICS: "NAICS", //NAICS
    NAICSDescription: "Descripción NAICS", //NAICSDescription
    CSIC: "CSIC", //CSIC,
    CSICDescription: "Descripción CSIC", //CSICDescription
    AAAIC: "AAAIC", //AAAIC
    AAAICDescription: "Descripción AAAIC", //AAAICDescription
    GICS: "GICS", //GICS
    GICSDescriptio: "Descripción GICS", //GICS 描述
  },
  ImportExport: {
    TotalImportAmount: "Importe total de importación", //进口总额
    TopImportCountry: "Principales países de importación", //最大进口国家/地区
    TopImportProduct: "Principales productos de importación", //最大进口产品
    TotalExport: "Exportación total", //出口总额
    TopExportCountry: "Principales países de exportación", //最大出口国家/地区
    TopExportProduct: "Principales productos de exportación", //最大出口产品
    TradeVolume: "Volumen comercial", //贸易额
    ImportShipments: "Envíos de importación", //进口量
    ExportShipments: "Envíos de exportación", //出口量
    ImportCountries: "Países de importación", //进口国家/地区
    ExportCountries: "Países de exportación", //出口国家/地区
    ImportVolume: "Volumen de importación", //进口量
    ExportVolume: "Volumen de exportación", //出口量
    Suppliers: "Principales proveedores", //主要供应商
    Shipments: "Por número de envíos", //按出货量
    Buyers: "Principales compradores", //主要买家
    ImportQuantity: "Cantidad de importación", //进口数量
    IncreaseDecreasexRate: "Tasa de aumento/disminución", //增/减率
    ExportQuantity: "Cantidad de importación", //出口数量
    ImportsExportsRecords: "Registros de importaciones y exportaciones", //进出口记录
    Date: "Fecha", //日期
    Product: "Producto", //产品
    HSCode: "Código SA", //HS 编码
    BuyerName: "Nombre del comprador", //买家名称
    Destination: "Destino", //目的地
    SupplierName: "Nombre del proveedor", //供应商名称
    Origin: "Origen", //原产地
    Amount: "Monto (USD)", //金额
    Details: "Detalles", //详情
    Selectdate: "Seleccione la fecha",

    //未对应
    Imports: "Imports",
    Exports: "Exports",
    Shipments2: "Shipments",
    value2: "value",
    value: "By Number of value",
    viewmoretradeinfo: "view more trade info",
    SearchHSCode: "Search HS Code",
  },
  SupplyChain: {
    //未对应
    Illustratesthesubjectcompany:
      "This chart illustrates the subject company’s “buy from” and “sell to” relationships. The larger the volume, the thicker the tube.",
  },
  ShippingOrderDetails: {
    Date: "Fecha",
    MasterBillofLading: "Conocimiento de Embarque Maestro",
    Source: "Origen",
    BillNo: "N.° de conocimiento",
    ImporterBuyer: "Importador/Comprador",
    ExporterSeller: "Exportador/Vendedor",
    Name: "Nombre",
    Address: "Dirección",
    Country: "País",
    Contact: "Contacto",
    Email: "Correo electrónico",
    CargoInfo: "Información de la carga",
    HSCode: "Código SA",
    Quantity: "Cantidad",
    WeightUnit: "Unidad de peso",
    ProductDescription: "Descripción del producto",
    Amount: "Monto (USD)",
    QuantityUnit: "Unidad de cantidad",
    Weight: "Peso",
    HSDescription: "Descripción SA",
    Incoterms: "Incoterms",
    ShippingInfo: "Información de envío",
    Vessel: "Buque",
    Consignee: "Destinatario",
    MeansofTransport: "Medio de transporte",
    CountryofOrigin: "País de origen",
    Voyage: "Viaje",
    Notifier: "Notificador",
    CountryofDestnation: "País de destino",
    AddressofOrigin: "Dirección de origen",
    Shipper: "Expediente",
    AddressofDestnation: "Dirección de destino",
    Container: "Contenedor",
    ContainerID: "ID del contenedor",
    ContainerType: "Tipo de contenedor",
    ContainerDescDode: "Dirección de descripción del contenedor",
    ContainerSize: "Tamaño del contenedor",
    //未对应
    ImportExport: "Importador / Exportador", 
    Imports: "Imports",
    Exports: "Exports",
  },
  FinancialHighlight: {
    Revenue: "Ingresos", //收入
    Profit: "Beneficios", //利润
    Growth: "Crecimiento", //增长
    Liquidity: "Estado del flujo de caja", //现金流状况
    FinancialStructure: "Estructura financiera", //融资结构
    CreditOpinion: "Opinión crediticia", //信用评估
    RiskIndicator: "Indicador de riesgo", //风险指标
    Solvencyindex: "Índice de solvencia", //偿还指数
    Year: "Año", //年份
    Change: "Cambio", //变化
    NetProfit: "Beneficio neto",
    TotalAssets: "Activos totales",
    Equity: "Patrimonio neto",
    GrossMargin: "Margen bruto",
    ProfitMargin: "Margen de beneficio",
    ReturnonEquity: "Rentabilidad del capital propio",
    CurrentRatio: "Ratio de liquidez",
    DebtRatio: "Ratio de endeudamiento",
    FinancialHighlights: "Datos financieros de las empresas vinculadas", //关联公司财务数据
    FinancialHighlightsTitle:
      "Información financiera destacada de las empresas vinculadas", //关联公司财务摘要
    CompanyName: "Nombre de la empresa", //公司名称
    CompanyID: "ID de la empresa", //公司ID
    Country: "País", //国家/地区
    CompanyStatus: "Estado de la empresa", //公司状态
    Relations: "Relaciones", //关系
    Cancel: "Cancelar", //取消
    Select: "Seleccionar",
    RatioAnalysis: "Análisis de índices de las empresas vinculadas", //关联公司比率分析
    //未对应
    Financialperformancedata:
      "Financial performance data is collected from various governmental sources and local credit reporting agencies. Additionally, market and industry research is used to calculate and model the data. For more detailed information about the actual operations and performance analysis, please contact our service team to request a company due diligence report.",
    Whenthesubjectsdata:
      "When the subject’s data is insufficient, or you’re interested in gaining more insights into your customer, this platform offers a comprehensive view of all entities related to the subject. This includes the subject’s company’s shareholders, related companies, and more.",
    Byprovidingyou:
      "By providing you with a broader perspective, this platform empowers you to make more informed evaluations and gain a deeper understanding of your subject.",
    PleaseSelectTheYeartoDisplay: "Please Select The Year to Display",
    SelectUptoThreeYears: "Select Up to Three Years",
  },
  RatioAnalysis: {
    ProfitabilityRatios: "Índices de rentabilidad",
    Year: "Año", //年份
    Change: "Cambio", //变化
    Returnonequity: "Rentabilidad del capital",
    Returnonassets: "Rentabilidad de los activos",
    Profitmargin: "Margen de beneficio",
    Grossmargin: "Margen bruto",
    OperatingRatios: "Índices operativos",
    Assetsturnover: "Rotación de activos",
    Stockturnover: "Rotación de existencias",
    Salesperiod: "Periodo de ventas",
    Collectionperiod: "Periodo de cobro",
    Creditperiod: "Periodo de crédito",
    StructuralRatios: "Índices de estructura",
    Currentratio: "Ratio de liquidez",
    Quickratio: "ratio de liquidez inmediata",
    Shareholdersliquidityratio: "Ratio de liquidez de los accionistas",
    Solvencyratio: "Ratio de solvencia",
    Debtratio: "Ratio de endeudamiento",
    ProductivityRatios: "Índices de productividad",
    Profitperemployee: "Beneficio por empleado",
    Operatingrevenueperemployee: "Ingresos operativos por empleado",
    Shareholdersfundsperemployee: "Fondos propios por empleado",
    Totalassetsperemployee: "Activos totales por empleado",
    GrowthRatios: "Índices de crecimiento",
    Salesgrowthrate: "Tasa de crecimiento de las ventas",
    Netprofitgrowthrate: "Tasa de crecimiento del beneficio neto",
    Totalassetsgrowthrate: "Tasa de crecimiento de los activos totales",
    FinancialHighlights: "Datos financieros de las empresas vinculadas", //关联公司财务数据
    RatioAnalysis: "Análisis de índices de las empresas vinculadas", //关联公司比率分析
    CompanyName: "Nombre de la empresa",
    CompanyID: "ID de la empresa",
    Country: "País",
    CompanyStatus: "Estado de la empresa",
    Relations: "Relaciones",
  },
  IndustryNorms: {
    IndustryStatistics: "Estadísticas del sector",
    ofcompaniesintheIndustry: "N.° de empresas del sector",
    oflistedCompaniesintheIndustry:
      "N.° de empresas que cotizan en bolsa en el sector",
    oflargecompaniesintheIndustry: "N.° de grandes empresas del sector",
    ofSMEsintheIndustry: "N.° de pymes del sector",
    ofcompaniesinsample: "N.° de empresas de la muestra",
    ofcompaniesinloss: "N.° de empresas con pérdidas",
    Observations: "Observaciones",
    AverageValue: "Valor medio",
    MedianValue: "Valor medio",
    MaximumValue10: "Valor máximo 10%",
    MinimumValue10: "Valor mínimo 10%",
    SubjectCompany: "Empresa en cuestión",
    YearsinBusiness: "Años en el mercado",
    TotalAssets: "Activos totales",
    TotalEquity: "Patrimonio neto total",
    Revenue: "Ingresos",
    NetEarning: "Beneficio neto",
    Returnonassets: "Rentabilidad de los activos",
    Performance: "Rendimiento",
    ProfitabilityRatios: "Ratios de rentabilidad",
    Returnonequity: "Rentabilidad del patrimonio neto",
    Returnonassets: "Rentabilidad de los activos",
    Grossmargin: "Margen bruto",
    OperatingRatios: "Ratios operativos",
    Stockturnover: "Rotación de existencias",
    Accountsreceivableturnover: "Rotación de cuentas por cobrar",
    Assetsturnover: "Rotación de activos",
    Totalassetturnover: "Rotación de activos totales",
    StructuralRatios: "Ratios de estructura",
    Currentratio: "Ratio de liquidez",
    Quickratio: "ratio de liquidez inmediata",
    Shareholdersliquidityratio: "Ratio de liquidez de los accionistas",
    GrowthRatios: "Ratios de crecimiento",
    Salesgrowthrate: "Tasa de crecimiento de las ventas",
    Netprofitgrowthrate: "Tasa de crecimiento del beneficio neto",
    Totalassetsgrowthrate: "Tasa de crecimiento de los activos totales",
  },
  Lawsutis: {
    //未对应
    Lawsutis: "Lawsutis",
    Date: "Date",
    CaseCategory: "Case Category",
    Title: "Title",
    CaseNo: "Case No.",
    CauseofAction: "Cause of Action",
  },
  News: {
    Date: "Fecha", //日期
    Title: "Título", //标题
    Source: "Fuente", //来源
    Impact: "Impacto", //影响
    Searchcompanies: "Buscar más noticias sobre otras empresas", //国家/地区
    //未对应
    SearchforTitle: "Search for Title",
    CompanyName:"Company Name",
    Industry: "Industry",
    Subjects:"Subjects",
    NewsTypes:"News Types",
    ByDate:"By Date",
    SelectCompanyName:"Select Company Name",
    SelectIndustry: "Select Industry",
    SelectSubjects:"Select Subjects",
    SelectNewsType:"Select News Type",
    Negative:"Negative",
    Positive:"Positive",
  },
  Sanctions: {
    Potentialcompliance: "Se detectaron posibles riesgos de incumplimiento.", //检测到潜在合规风险
    SeachbuttonNo: "No se detectó ningún problema en esta empresa.", //未检测到任何与该公司相关的不良记录
    SeachbuttonYes:
      'Para buscar más registros de sanciones, haga clic en el botón "Buscar sanciones".', //要搜索更多制裁记录，请点击“搜索制裁”按钮。
    SearchSanctions: "Buscar sanciones", //搜索制裁
    ViewDetails: "Ver detalles", //查看详情
    Sanctions: "Sanciones", //制裁
    Potentialcompliancerisks: "Posibles riesgos de incumplimiento", //潜在合规风险
    IDInfo: "Información de ID", //ID 信息
    IDType: "Tipo de ID", //ID 类型
    IDDescription: "Descripción de ID", //ID 描述
    SanctionList: "Lista de sanciones", //制裁名单
    SanctionListInvolved: "Lista de sanciones involucradas", //涉及的制裁名单
    StartDate: "Fecha de inicio", //生效日期
    EndDate: "Fecha de finalización", //结束日期
    SourceList: "Lista de fuentes", //来源名单
    SourceName: "Nombre de la fuente", //来源名称
    ProfileNotes: "Notas del perfil", //主体资料
    Link: "Enlace", //链接
    Name: "Nombre", //名称
    //未对应
    AssociationList: "Association List",
    AssociationID: "Association ID",
    AssociationType: "Association Type",
  },
  CreditOpinion: {
    CreditAssessment: "Evaluación crediticia",
    CreditAssessmentfromtheRelatedCompanies:
      "Evaluación crediticia de las empresas relacionadas",
    Year: "Año",
    CreditRating: "Calificación crediticia",
    LocalCreditScore: "Puntuación crediticia local",
    ProbabilityofDefault: "Probabilidad de incumplimiento",
    SolvencyIndex: "Índice de solvencia",
    CreditLine: "Línea de crédito",
    RiskIndicator: "Indicador de riesgo",
    RelatedCreditAssessment: "Evaluación crediticia relacionada",
    CompanyName: "Nombre de la empresa",
    CompanyID: "ID de la empresa",
    Country: "País",
    CompanyStatus: "Estado de la empresa",
    Relations: "Relaciones",
    Cancel: "Cancelar", //取消
    Select: "Seleccionar",
    //未对应
    LocalCreditScore: "Local Credit Score",
    SolvencyIndex: "Solvency Index",
    ProbabilityofDefault: "Probability of Default",
    RiskIndicator: "Risk Indicator",
    CreditAssessmentMessage1:
      "When the subject’s data is insufficient, or you’re interested in gaining more insights into your customer, this platform offers a comprehensive view of all entities related to the subject. This includes the subject’s company’s shareholders, related companies, and more.",
    CreditAssessmentMessage2:
      "By providing you with a broader perspective, this platform empowers you to make more informed evaluations and gain a deeper understanding of your subject.",
    LocalCreditRating: "Local Credit Rating",
    LocalCreditRatingDetail:
      "Driven by the power of big data, 3ARating is a quantitative rating system for private companies. It is a collaborative effort between 3ACredit and Creditreform Rating. The rating model is built based on a comprehensive evaluation of various key factors, including non-financial factors, financial factors, negative records, and industry-specific considerations. The rating model exhibits an impressive Gini coefficient, indicating its robustness and reliability. 3ARating spans a range of ratings, from the highest rating, 3A1, to the lowest rating class, 3A19.",
    CreditScore: "Credit Score",
    CreditScoreDetail:
      "Credit scores are calculated on a scale from 1 to 100, based on the credit rating obtained from local authorities. A higher score indicates better creditworthiness.",
    PossibilityofDefault: "Possibility of Default (PD)",
    PossibilityofDefaultDetail:
      "The Possibility of Default (PD) is a useful tool for risk assessment, focusing on short-term liquidity evaluation.",
    SolvencyIndexSI: "Solvency Index (SI)",
    SolvencyIndexSIDetail:
      "The Solvency Index (SI) is a highly effective and reliable early warning indicator that allows for a rapid assessment of the solvency of business partners. A higher SI value indicates a higher risk of default by a client. The SI ranges from 100, which is considered an excellent rating, to 600, where highly negative characteristics are present.",
    ExternalRating: "External Rating",
    DefaultProbability: "Default Probability (Pd1Year)",
    Rating: "3ARating (>=,<=)",
    PleaseSelectTheYeartoDisplay: "Please Select The Year to Display",
    SelectUptoThreeYears: "Select Up to Three Years",
    HighRisk: "High Risk",
    Medium: "Medium",
    Moderate: "Moderate",
    Average: "Average",
    LowerThanAvg: "Lower Than Avg",
    LowRisk: "Low Risk",
    CreditOpinion: "Credit Opinion",
  },
  IndustryStatistics: {
    SubjectCompany: "Empresa",
    Country: "País",
    Compare: "Comparar",
    Industry: "Sector",
    CompanyType: "Tipo de empresa",
    CompanySize: "Tamaño de la empresa",
    CompanyStatus: "Estado de la empresa",
    YearsinBusiness: "Años en el mercado",
    CompanyRating: "Calificación de la empresa",
    Liquidity: "Estado del flujo de caja",

    //未对应
    NoofcoinIndustry: "No. of co. in Industry",
    IndustryRating: "Industry Rating",
    Profitability: "Profitability",
    Repaying: "Repaying",
    SearchCountry: "Search Country",
    //未对应

    Growth: "Crecimiento",
    FinancialStructurt: "Estructura financiera",
  },
  RatingAnalysis: {
    IndustyAnalysis: "Análisis del sector",
    GeographicAnalysis: "Análisis geográfico",
    CompanyTypeAnalysis: "Análisis del tipo de empresa",
    BiusinessScaleAnalysis: "Análisis de la escala de negocio",
    HistoryAnalysis: "Análisis histórico",
    NormalDistribution: "Distribución normal",
    SubjectCompany: "Empresa del sujeto",
    Probabilityofthesubjectratinginitsindustry:
      "Probabilidad de la calificación del sujeto en su sector",
    Maximum: "Máximo 10%",
    Mean: "Media",
    Average: "Promedio",
    Minimum: "Mínimo 10%",
    RatingDistribution: "Distribución de la calificación",
    Revenue: "Ingresos",
    Earning: "Ganancias",
    TotalAssets: "Activos totales",
    Subjectratinginitsindustrybyfinancialindicators:
      "Calificación del sujeto en su sector según indicadores financieros",
    Best: "Mejor",
    Worst: "Peor",
    Rankingofsubject:
      "Clasificación de la calificación del sujeto en el sector",
    Industy: "Sector",
    Percentilerank:
      "Percentil: % de empresas con una calificación igual o inferior a la del sujeto",
    Historicaldevelopmentofsubject:
      "Evolución histórica de la calificación del sujeto en su sector",
    IndustryAverage: "Promedio del sector",
    SubjectRatingChanges: "Cambios en la calificación del sujeto",
    CompanySize: "Tamaño de la empresa",
    YearsinBusiness: "Años en el mercado",
    //未对应
    CreditScore: "Credit Score",
    NOofCompanies: "NO. of Companies",
    ofCompanies: "% of Companies",
    CreditRating: "Credit Rating",
    SubjectsIndustryConcentrationAnalysis:
      "Subject's Industry Concentration Analysis",
    GeographicdistributionofSubjectsratingintsindustry:
      "Geographic distribution of Subject's rating in its industry",
    GeographicdistributioninSubjectindustry:
      "Geographic distribution in Subject's industry：",
    RatingDistributioninSubjectsLocation:
      "Rating Distribution in Subject's Location",
    Ratinganalysisofcompanies:
      "Rating analysis of companies in the same industry with different years in business",
    Subjectsratinghistory:
      "Subject's rating history comparing with its peers with the same history",
    Ratingrankingofcompanieswithsamehistory:
      "Rating ranking of companies with same history",
    Ratingstatistics:
      "Rating statistics of companies with the same years in business",
    Subjectratingcomparing:
      "Subject rating comparing with its peer companies with the",
    Subjectratinginitsgroup: "Subject rating in its group:",
    Analysisbasedonnature:
      "Analysis based on nature of companies in subject's industry",
    Subjectratingpositioninitscompanytype:
      "Subject rating position in its company type:",
    Ratingstatisticsofcompanies:
      "Rating statistics of companies in the same industry",
    Ratinganalysisofcompanies:
      "Rating analysis of companies of different sizes in the same industry",
    Probabilityofsubjectrating:
      "Probability of subject rating in its industry within its size",
    Subjectratingcomparingwithindustry:
      "Subject rating comparing with its peers in its industry:",
    RatingRankingofthecompanies:
      "Rating Ranking of the companies in the same size in the same industry",
    Ratingstatisticsofcompanies:
      "Rating statistics of companies in the same size and same industry",
    Rank: "Rank",
    Rating: "Rating",
  },
  CompetitiveAnalysis: {
    MarketPosition: "Posición en el mercado",
    Revenus: "Ingresos",
    NetEarnings: "Beneficio neto",
    NetAssets: "Activo neto",
    TotalAssets: "Activo total",
    Employees: "Empleados",
    Mean: "Media",
    Average: "Promedio",
    Maximum: "Máximo (10%)",
    Worst: "Peor (10%)",
    Subjectcompany: "Empresa en cuestión",
    PerformanceComparison: "Comparación de rendimiento",
    ProfitabilityRatios: "Ratios de rentabilidad",
    Grossmargin: "Margen bruto",
    Returnonassets: "Rendimiento sobre activos",
    Returnonequity: "Rendimiento sobre el capital",
    OperatingRatios: "Ratios operativos",
    Stockturnover: "Rotación de existencias",
    Assetsturnover: "Rotación de activos",
    Collectionperiod: "Periodo de cobro",
    GrowthRatios: "Ratios de crecimiento",
    Totalassetsgrowthrate: "Tasa de crecimiento de los activos totales",
    Salesgrowthrate: "Tasa de crecimiento de las ventas",
    Netprofitgrowthrate: "Tasa de crecimiento del beneficio neto",
    StructuralRatios: "Ratios de estructura",
    Debtratio: "Ratio de endeudamiento",
    Quickratio: "ratio de liquidez inmediata",
    Currentratio: "Ratio de liquidez",
  },
  AccountCenterMenu: {
    SearchinSettings: "Buscar en Configuración", //在“设置”中搜索
    Account: "Cuenta", //账户
    MyAccount: "Mi cuenta", //我的账户
    ContactInfo: "Información de contacto", //联系信息
    AccountSecurity: "Seguridad de la cuenta", //账户安全
    OrganizationalManagement: "Gestión de la organización", //组织管理
    UserGroup: "Grupo de usuarios", //用户组
    User: "Usuario", //用户
    Role: "Rol", //角色
    MyDatabase: "Mi base de datos", //我的数据库
    MyUsage: "Mi uso", //我的使用情况
    CompaniesViewed: "Empresas consultadas", //查看过的公司
    ReportsDownloaded: "Informes descargados", //下载的报告
    ReportUpdatesOrdered: "Actualizaciones de informes solicitadas", //订购的报告更新
    BillingandPayment: "Facturación y pagos", //账单和付款
    BillRecords: "Registros de facturas", //账单记录
    PaymentRecords: "Registros de pagos", //付款记录
    CreditDeductions: "Deducciones de crédito", //信用扣款
    InvoicesDownloaded: "Facturas descargadas", //下载的发票
    UserSettings: "Configuración de usuario", //用户设置
    Messages: "Mensajes", //消息
    Notifications: "Notificaciones", //通知
    HelpCenter: "Centro de ayuda", //帮助中心
    FAQ: "Preguntas frecuentes", //常见问题
    Privacy: "Privacidad", //隐私
    Terms: "Términos", //条款
    ReportIssues: "Informar de problemas", //报告问题
    UserGuide: "Guía del usuario", //用户指南
    AboutCSI: "Acerca de CSI", //关于CSI
  },
  MyAccount: {
    Logintime: "Hora de inicio de sesión", //登录时间
    SignOut: "Cerrar sesión", //退出
    DeleteAccount: "Eliminar cuenta", //删除账户
    AccountID: "ID de la cuenta", //账户ID
    Enteranewaddress: "Ingresar una nueva dirección de correo electrónico", //输入新的电邮
    EnterVerificationCode: "Ingresar código de verificación", //输入验证码
    SendverificationCode: "Enviar código de verificación", //发送验证码
    Password: "Contraseña", //密码
    Originalpassword: "Contraseña original", //原始密码
    Newpassword: "Nueva contraseña", //新密码
    Confirmnewpassword: "Confirmar nueva contraseña", //确认新密码
    AccountOwnership: "Propiedad de la cuenta", //账户所有权
    IndividualAccount: "Cuenta individual", //个人账户
    GroupAccount: "Cuenta de grupo", //集团账户
    Organizationname: "Nombre de la organización", //机构名称
    CountryRegion: "País/Región", //国家/地区
    Address: "Dirección", //地址
    City: "Ciudad", //城市
    ZipCode: "Código postal", //邮政编码
    FirstName: "Nombre", //名字
    LastName: "Apellidos", //姓氏
    PhoneNumber: "Número de teléfono", //电话号码
    Email: "Correo electrónico", //更改
    Change: "Cambiar", //更改
    Save: "Guardar", //保存
    Cancel: "Cancelar", //取消
    LastLogin: "Último inicio de sesión", //Last Login
    RecentLogin: "Inicio de sesión reciente", //登录尝试次数
    AverageLoginTime: "Tiempo promedio de inicio de sesión", //平均登录时间
    TotalLoginAttempts: "Intentos totales de inicio de sesión", //登录尝试次数
    //未对应
    Registrationtime: "Registration time",
    Role: "Rol",
    Administrator: "Administrator",
    Enterpriseusers: "Enterprise users",
    EditImage: "Edit Image",
    DeleteImage: "Delete Image",
  },
  ContactInfo: {
    ContactInfo: "Información de contacto",
    FirstName: "Nombre",
    LastName: "Apellidos",
    PhoneNumber: "Número de teléfono",
    Email: "Correo electrónico",
    CountryRegion: "País/Región",
    AddressLine: "Dirección",
    City: "Ciudad",
    ZipCode: "Código postal",
    Alternativecontactperson: "Persona de contacto alternativa",
    Setascontactperson: "Establecer como persona de contacto",
    Edit: "Editar",
  },
  AccountSecurity: {
    Setupmysecurityquestions: "Configurar mis preguntas de seguridad",
    Pleasechooseaquestion: "Elige una pregunta",
    Pleaseentertheanswertothequestion: "Introduce la respuesta a la pregunta",
    SessionTimeoutAutomaticLogoutSettings:
      "Tiempo de espera de la sesión: Configuración de cierre de sesión automático",
    Thesystemwillautomatically:
      "El sistema cerrará tu sesión automáticamente tras un periodo de inactividad. El tiempo de espera predeterminado es de 5 minutos, pero puedes ajustarlo según tus necesidades.",
  },
  MyDatabase: {
    TotalNumberofCompaniesSearched: "Número total de empresas buscadas",
    TotalNumberofCompaniesCollected: "Número total de empresas recopiladas",
    TotalNumberofUpdateReportsOrdered:
      "Número total de informes de actualización solicitados",
    Date: "Fecha",
    UserName: "Nombre de usuario",
    CompanyName: "Nombre de la empresa",
    Status: "Estado",
    UsageType: "Tipo de uso",
    Entercompanyname: "Introduzca el nombre de la empresa",
    Download: "Descargar",
  },
  OrganizationalManagement: {
    GroupName: "Nombre del grupo",
    ParentGroupName: "Nombre del grupo principal",
    Organization: "Organización",
    GroupID: "ID del grupo",
    GroupStatus: "Estado del grupo",
    Operation: "Operación",
    NewlyBuilt: "Creado recientemente",
    UserAccount: "Cuenta de usuario",
    Role: "Rol",
    AccountStatus: "Estado de la cuenta",
    RoleName: "Nombre del rol",
    Position: "Posición",
    RoleStatus: "Estado del rol",
    Valid: "Válido",
    Invalid: "Inválido",
    PermissionSettings: "Configuración de permisos",
    ShowMore: "Mostrar más",
    Search: "Buscar",
    Cancel: "Cancelar",
    Confirm: "Confirmar",
    //未对应
    NewGroup: "New Group",
    EnterGroupName: "Enter Group Name",
    NumberofGroups: "Number of Groups",
    Groups: "Groups",
    Roles: "Roles",
    NewRoles: "New Roles",
    EnterNewRole: "Enter New Role",
    Users: "Users",
    EnterUserName: "Enter User Name",
  },
  BillingandPayment: {
    TotalNumberofOrders: "Número total de pedidos",
    TotalPaymentAmount: "Importe total del pago",
    TotalUsedCredits: "Total de Créditos Utilizados",
    Date: "Fecha",
    UserAccount: "Cuenta de usuario",
    CompanyName: "Nombre de la empresa",
    OrderNo: "N.º de pedido",
    OrderType: "Tipo de pedido",
    OrderStatus: "Estado del pedido",
    Download: "Descargar",
    PaymentAmount: "Importe del pago",
    Contactus: "Contáctenos",
    DownloadInvoice: "Descargar factura",
    CreditUsage: "Uso del crédito",
    ReportOrderStatus: "Informar del estado del pedido",
    CompanyID: "ID de la empresa",
    CountryRegion: "País/Región",
    AddressLine: "Dirección",
    City: "Ciudad",
    ZipCode: "Código postal",
    FirstName: "Nombre",
    LastName: "Apellidos",
    PhoneNumber: "Número de teléfono",
    Email: "Correo electrónico",
    BankAccountHolderName: "Nombre del titular de la cuenta bancaria",
    BeneficiaryBankName: "Nombre del banco beneficiario",
    SWIFTCODE: "CÓDIGO SWIFT",
    AccountNumber: "Número de cuenta",
    BeneficiaryBankAddress: "Dirección del banco beneficiario",
    ABA: "ABA (Número de ruta)",
    IBANnumber: "Número IBAN",
    //未对应
    StartingMonth: "Starting Month",
    EndMonth: "End Month",
    InvoiceInfo:"Invoice Info",
  },
  UserSettings: {
    LanguageandLocation: "Idioma y ubicación",
    Language: "Idioma",
    Selectyourpreferedlanguage: "Seleccione su idioma preferido",
    Location: "Ubicación",
    Selectyourlocation: "Seleccione su ubicación",
    NotificationSetting: "Configuración de notificaciones",
    EmailNotification: "Notificaciones por correo electrónico",
    ServiceUpdates: "Actualizaciones del servicio",
    CompanyNews: "Noticias de la empresa",
  },
  AddCredit: {
    //未对应
    Customizeyourplan: "Customize your plan however you need",
    Silver: "Silver",
    Gold: "Gold",
    Enterpris: "Enterpris",
    Credit: "Credit",
    Remaining: "Remaining",
    Points: "points",
    Usermonth: "user/ month",
    Useryear: "user/ year",
    PaidMonthlyRenews: "Paid monthly, no need for auto renews",
    PaidAnnuallyRenews: "Paid annually, no need for auto renews",
    ForFullSupport: "for full support to your needs",
    Each: "each",
    CreditsCharged:
      "Credits charged to your account will never expire as long as your account remains active.",
    PaidMonthly: "Paid monthly",
    PaidAnnually: "Paid annually",
    BuyNow: "Buy now",
    ContactNow: "Contact now",
    SearchCompanies:
      "Search companies and get an instant access to company data that includes:",
    EverythinginSilverPackage: "Everything in Silver package, plus:",
    CreditsCanbeUsed:
      "Credits can be used for more data services including the followings:",
    UnlimitedAdvancedSearch: "Unlimited advanced search",
    ViewCompanyProfile: "View company profile",
    CompanyOwnershipStructure: "Company ownership structure",
    CompanyFamilyTree: "Company family tree",
    Companymanagement: "Company management",
    CompanyContactsinfo: "Company contacts info",
    BusinessActivities: "Business activities",
    IndustryBasics: "Industry basics",
    ImportExportRecords: "Import & export records",
    CompanyPublications: "Company publications",
    CompanyNews: "Company news",
    DownloadOnlineReport: "Download online report",
    ManagementDetails: "Management details",
    ShareholderPenetration: "Shareholder penetration (UBO)",
    Financialinfo: "Financial info",
    FinancialAnalysis: "Financial analysis",
    CreditAssessment: "Credit assessment",
    IndustryAnalysis: "Industry analysis",
    MarketAnalysis: "Market analysis",
    SupplyChaininfo: "Supply Chain info",
    CheckSanctions: "Check sanctions",
    CompanyComparison: "Company comparison",
    DataExport: "Data export",
    MonitoringService: "Monitoring service",
    DiscountForFreshUpdateReports: "Discount for fresh update reports",
    SearchCompany: "Search Company",
    SearchLeads: "Search Leads",
    SearchTrade: "Search Trade",
    SearchPeople: "Search People",
    SearchCountry: "Search Country",
    SearchNews: "Search News",
    SearchSanction: "Search Sanction",
    DataServices: "Data Services",
    APIPlans: "API Plans",
    VolumeDiscounts: "Volume Discounts",
    GroupAccountsWithMultipleUsers: "Group Accounts with multiple users",
    CustomizedPlans: "Customized Plans",
    FreshInvestigatedCreditReportsWorldwide:
      "Fresh investigated credit reports worldwide",
    BusinessMonitoringServices: "Business monitoring services",
    BusinessProcessVerificationServices:
      "Business process verification services",
    VendorComplianceReports: "Vendor compliance reports",
    MarketResearch: "Market research",
    More: "More…",
    Contactus: "Contact us",
    PaymentMethod: "Payment Method",
    CreditCardNumber: "Credit Card Number",
    EnterCardNumber: "Enter Card Number",
    ExpirationDate: "Expiration Date",
    Fullnameoncard: "Full name on card",
    EnterFullname: "Enter Full name",
    EnterProvinceState: "Enter Province / State",
    CVCCode: "CVC Code",
    EnterCVCCode: "Enter CVC Code",
    IncorrectCreditCardNumberformat: "Incorrect Credit Card Number format ",
    IncorrectExpMonthformat: "Incorrect Exp.Month format",
    IncorrectExpYearformat: "Incorrect Exp.Year format",
    IncorrectFullNameformat: "Incorrect Full Name format",
    IncorrectCountryformat: "Incorrect Country format",
    IncorrectProvinceStateformat: "Incorrect Province / State format",
    IncorrectCVCCodeformat: "Incorrect CVC Code format",
    TotalPurchase: "Total Purchase",
    Agree1: "By clicking “Submit”, you agree to the ",
    Agree2: "CSI Services Agreement and Privacy .",
    Submit: "Submit",
    Month: "Month",

    Year: "Año",
    Country: "País",
    ProvinceState: "Provincia/Estado",
    Cancel: "Cancelar",
  },
  ReportIssues: {
    Whattypeoferrorsyouarereporting: "Qué tipo de errores reporta?",
    Tellusmoreaboutyourproblems: "Cuéntenos más sobre sus problemas.",
    Wouldyouliketoprovideascreenshotorafileregardingyourproblem:
      "Desea proporcionar una captura de pantalla o un archivo sobre su problema?",
    Fillinyourcontactinformation: "Complete su información de contacto",
    FirstName: "Nombre",
    LastName: "Apellidos",
    PhoneNumber: "Número de teléfono",
    Email: "Correo electrónico",
    Edit: "Editar",
  },
  //Risk Scan
  RiskScan: {
    RiskScan: "Risk Scan",
    RiskScanInfo:
      " es su plataforma integral para obtener información completa sobre riesgos corporativos. Ofrecemos análisis detallados en todas las categorías de riesgo principales para proteger sus decisiones empresariales.",
    LegalRisk: "Riesgo legal",
    LegalRiskInfo: "Verificar la legitimidad de la empresa.",
    OrganizationalRisk: "Riesgo organizacional",
    OrganizationalRiskInfo:
      " Estabilidad de la gestión, complejidad de la estructura corporativa y transparencia de la propiedad.",
    OperationalRisk: "Riesgo operacional",
    OperationalRiskInfo:
      "Vulnerabilidades de la cadena de suministro, estado operacional y exposición geopolítica.",
    FinancialRisk: "Riesgo de desempeño financiero",
    FinancialPerformanceRiskInfo:
      "tendencias de rentabilidad, problemas de liquidez y salud del balance general.",
    CreditRisk: "Riesgo de crédito",
    CreditRiskInfo:
      "Creditworthiness, payment history, and probability of default.",
    ComplianceRisk: "Riesgo de incumplimiento",
    ComplianceRiskInfo:
      "Cumplimiento de las sanciones, las normas contra el blanqueo de capitales y las leyes específicas del sector.",
    SustainabilityRisk: "Riesgo de sostenibilidad",
    SustainabilityRiskInfo:
      "factores ESG (ambientales, sociales y de gobernanza) e impactos en la reputación.",
    IndustryRisk: "Riesgo sectorial",
    IndustryRiskInfo:
      "Evalúa la estabilidad y las perspectivas de todo el sector de una empresa.",
    LetBegin: "Comencemos",
    AddcompaniesfromSearchResult:
      "Agregar empresas de los resultados de búsqueda",
    AddcompaniesfromMyDatabase: "Agregar empresas de Mi base de datos",
    Addcompaniesbyuploadmyownlist: "Añadir empresas subiendo mi propia lista",
    Cancel: "Cancelar",
    Confirm: "Confirmar",
    UploadFiles: "Subir archivos",
    PleaseuploadyourfileinCVSformat:
      "Por favor, suba su archivo en formato xlsx.",
    Downloadxlsxtemplate: "Descargar plantilla xlsx",
    //语序问题未对应
    Xcompanieswereuploadedsucessfuly: "companies were uploaded sucessfuly.",
    Xcompanieswereidentifiedsucessfuly: "companies were identified sucessfuly.",
    Xcompanieswerenotmatched: "companies were not matched.",

    Uploadingfilefailed:
      "No se pudo cargar el archivo. Utilice la plantilla e inténtelo de nuevo.",
    ALL: "Todos",
    SearchLeads: "Prospectos de búsqueda",
    LastUpdate: "Última actualización",
    CompanyID: "ID de la empresa",
    CompanyType: "Tipo de empresa",
    RegistrationDate: "Fecha de registro",
    RegistrationStatus: "Estado de registro",
    Listed: "cotiza en la bolsa de valores",
    LegalStatus: "Estatus legal",
    NoofShareholders: "Número de accionistas",
    ShareholdingLayers: "niveles de accionistas",
    NoofCorporateShareholders: "Número de accionistas corporativos",
    NoofNatualPersonShareholders: "Número de accionistas personas físicas",
    RelatedCompanies: "Empresas relacionadas",
    OrganizationalStatus: "Estado organizativo",
    OperatingAddress: "Dirección de funcionamiento",
    IndustryCode: "Código de la industria",
    BusinessActivities: "Actividades de negocio",
    NoofEmployees: "Número de empleados",
    Management: "Gestión",
    CurrentOperations: "Operaciones actuales",
    Revenue: "volumen de negocios",
    Assests: "Activos",
    ProfitLoss: "Ganancias/Pérdidas",
    Liquidity: "Liquidez",
    Growth: "crecimiento",
    Performance: "rendimiento operativo",
    CreditRating: "clasificación crediticia",
    CreditScore: "Puntuación de crédito",
    PausibilityofDefault: "Pausa por defecto (PD)",
    SolvencyIndex: "Índice de solvencia",
    DebtCollection: "cobro de deudas",
    CreditOpinion: "Opinión crediticia",
    CompanySanction: "de sanciones corporativas",
    ProductSanction: "Sanción del producto",
    ExportControl: "Control de exportaciones",
    AntiCorruptionAntiBribery: "Anticorrupción y antisoborno",
    Litigations: "Litigios",
    NegativeNews: "Noticias negativas",
    ESGScore: "Puntuación ESG",
    YearsinBusiness: "Años en el negocio",
    Competitiveness: "Competitividad",
    WorkingCapital: "Riesgo de mercado",
    FinancialStructure: "Índice de la cadena de suministro",
    Industrystatus: "Situación de la industria",
    IndustryOutlook: "Perspectivas del sector",
    NoofCompanies: "Numero di aziende",
    IndustryRanking: "Clasificación del sector",
    IndustryConcentration: "% del PIB del sector",
    IndustryCompetitiveness: "Industry Competitiveness", //未对应
    IndustryDevelopment: "Industry Development", //未对应
    CompanyName: "Nombre de la empresa",
    Legal: "Riesgo legal",
    Organizational: "Riesgo organizacional",
    Operational: "Riesgo operacional",
    Financial: "Riesgo financiero",
    Credit: "Riesgo de crédito",
    Compliance: "riesgos de cumplimiento",
    Sustainability: "Sostenibilidad",
    Industry: "Riesgo industrial",
    Download: "Descargar",
    StartDate: "Fecha de inicio",
    EndDate: "Fecha de finalización",
    Entercompanyname: "Introduzca el nombre de la empresa",
    Tryagain: "Intentar otra vez",
    //未对应
    Uploadyourlistofcompanies:
      "Upload your list of companies, and Risk Scan will provide you with instant data updates for each entity. With comprehensive risk assessments across seven risk categories, Risk Scan transforms your risk management from reactive to a proactive strategic advantage.",
    Choose: "Choose",
    Upload: "Upload",
    Uploading: "Uploading",
    Uploadwithamaximumfilesizeof1M:
      "(Upload up to 100 pieces of data at a time, with a maximum file size of 1M)",
    Theuploadedonlyxlsx: "The uploaded file can only be in xls/xlsx format",
    RiskScanning: "Risk Scanning",
    Youhaveselectedatotalof: "You have selected a total of",
    Tostartriskscanning: "companies, click “confirm” to start risk scanning",
    Datascanningisinprogress: "Data scanning is in progress ...",
    ClearAll: "Clear All",
    SelectUpdateDate: "Select Last Update",
    UpdateStatus: "Update Status",
    Updated: "Updated",
    Notupdated: "Not updated",
    Updating: "Updating",
    SelectRiskValue: "Select Risk Value",
    ReSelectData: "Re Select Data",
    HistoricalData: "Historical Data",
    DiagnosticReport: "Diagnostic Report",
    Good: "Good",
    General: "General",
    Differ: "Differ",
    NotEvaluated: "Not Evaluated",
    ScanTime: "Scan Time",
  },
  //Data Management
  DataManagement: {
    DataManagement: "gestión de datos",
    AllCompanies: "Todas las empresas",
    CompaniesViewed: "Empresas vistas",
    CompaniesCollected: "Empresas recogidas",
    CompaniesUploaded: "Empresas cargadas",
    MyPortfolio: "Mi portafolio",
    Date: "Fecha",
    CompanyName: "Nombre de empresa",
    Country: "País",
    CompanyType: "Tipo de empresa",
    CompanyStatus: "Estado de la empresa",
    DQI: "DQI",
    Download: "Descargar",
    Addcompanies: "Agregar empresas",
    Filter: "Filtrar",
    Selectcountry: "Seleccionar país",
    Selectindustry: "Seleccionar industria",
    Selectcompanytype: "Seleccione el tipo de empresa",
    Selectcompanysize: "Seleccione el tamaño de la empresa",
    Selectcompanystatus: "Seleccionar el estado de la empresa",
    Selectlistedcompanies: "Seleccionar empresas cotizadas",
    Selectcompanyyearsinbusiness:
      "Seleccione los años de actividad de la empresa",
    Industry: "Industria",
    CompanySize: "Tamaño de la empresa",
    Listed: "cotizan en bolsa",
    CompanyAge: "Edad de la empresa",
    SelectYear: "Seleccione año",
    SelectQuarter: "Seleccionar trimestre",
    SelectMonth: "Seleccionar mes",
    Reset: "Reiniciar",
    Search: "Buscar",
    MyDatabase: "Mi base de datos",
    Locations: "Ubicaciones",
    YearsinBusiness: "Años en el negocio",
    CompanyDQI: "DQI",
    RiskScan: "Análisis de riesgos",
    CreditAssessment: "Evaluación de crédito",
    Uptodate: "A hoy",
    Average: "Promedio",
    Insufficient: "Insuficiente",
    Good: "Buena",
    Caution: "Precaución",
    Unknown: "Precaución",
    CompanyTag: "Etiqueta de la empresa",
    Remove: "Eliminar",
    Uploaded: "Subido",
    Identified: "Identificada",
    Notmatched: "No coincidente",
    Identifythecompanywithmanualcheck:
      "Identificar la empresa con verificación manual",
    Identifyacompanymanually: "Identificar una empresa manualmente",
    Pleaseprovideanyrelevantinformation:
      "Proporcione cualquier información relevante que pueda mejorar los resultados de la búsqueda. Nuestro analista de datos le asignará la empresa más adecuada.",
    RegistrationID: "ID de empresa",
    StateProvince: "Estado/Provincia",
    Address: "direccion",
    Otherinformation: "Otra información",
    Submit: "Entregar",
    Cancel: "Cancelar",
    Confirm: "Confirmar",
    PortolioName: "Portolio Name",
    User: "Usuaria",
    Task: "Tarea",
    NoofCompanies: "Número de empresas",
    Entercompanyname: "Introduzca el nombre de la empresa",
    SaveYourPortfolio: "Guarde su cartera",
    PortfolioName: "Nombre de Portolio",
    Notes: "Notas",

    //未对应
    UploadCompanies: "Upload Companies",
    Match: "Match",
    Delete: "Delete",
    Edit: "Edit",
    EnterRegistrationID: "Enter Registration ID",
    EnterAddress: "Enter Address",
    EnterInformation: "Enter Information",
    EnterPortfolioName: "Enter Portfolio Name",
    EnterUserName: "Enter User",
    SelectTaskName: "Select Task",
    EnterNotes: "Enter Notes",
    OnlineMatching: "Online Matching",
    StartingMonth: "Starting Month",
    EndMonth: "End Month",
  },
  ...esLocale,
};

export default es;
